{
  "home": "Ana sayfa",
  "games": "Oyunlar",
  "casino": "Casino",
  "sports": "Spor",
  "bonuses": "Bonuslar",
  "wallet": "Kasa",
  "menu": "Menü",
  "profile": "Hesap",
  "login": "Giriş yap",
  "loginSoon": "Giriş — yakında",
  "vipCashback": "VIP Cashback",
  "invite": "Davet"
}
